import styled, { keyframes } from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";

const fadeIn  = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeOut = keyframes`from { opacity: 1; } to { opacity: 0; }`;
const slideUp = keyframes`from { transform: translateY(2%); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;
const slideDown = keyframes`from { transform: translateY(0); opacity: 1; } to { transform: translateY(2%); opacity: 0; }`;


export const DialogOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: var(--cemboo-modal-z, 1050);

    &[data-state="open"]   { animation: ${fadeIn}  200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${fadeOut} 150ms ease forwards;
        pointer-events: none;
    }
`;

export const DialogContent = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.modalBg};
    z-index: var(--cemboo-modal-z, 1050);
    overflow: hidden;

    &[data-state="open"]   { animation: ${slideUp}   200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${slideDown} 150ms ease forwards;
        pointer-events: none;
    }

    &:focus {
        outline: none;
    }
`;

export const ModalHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    background: #000;
`;

export const ModalTitleText = styled(Dialog.Title)`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.modalColor};
`;

export const CloseButton = styled(Dialog.Close)`
    background: transparent;
    border: none;
    color: #fff;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
    opacity: 0.7;

    &:hover {
        opacity: 1;
    }
`;

export const ModalBodyWrapper = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;